import React from 'react';
import formatTime from '../../../utils/formatTime';

export default class Time extends React.Component {
  state = {
    currentTime: "00:00:00"
  }

  setTimeString= () => {
    setInterval(() => {
      const currentDate = new Date(Date.now());
      const currentTime = formatTime(currentDate.getHours())
        + ":" + formatTime(currentDate.getMinutes()) + ":" + formatTime(currentDate.getSeconds());

      this.setState({
        currentTime:  currentTime
      })
    }, 1000);   
  }

  componentDidMount() {
    this.setTimeString()
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    }
  }

  render() {
    return (
      <React.Fragment>
        <h5>Time</h5>
        <div
          className="Time-info"
          style={{textAlign:"center"}}
        >
          😀{this.state.currentTime}
        </div>     
      </React.Fragment>
    )
  }
}